
const AppConfig = {
  barrageCost : '2.00',
  uploadImgMax: 8,
  preTaskMin: 0.05,

  MAP_SCALE_NORMAL: 15,//地图缩放比例(最大, 最小值)
  MAP_SCALE_SMALL: 13.8,//

  ctx: null,
  h5ver: '1.06',

  init(ctx) {
    this.ctx = ctx;

    if(this.h5ver != ctx.$preference.getH5Ver()){
      localStorage["jiashuju"] = ''
      // ctx.$preference.saveOwnInfo({})
      ctx.$preference.setH5Ver(this.h5ver)
    }
  },
}

AppConfig.install = function (Vue, options) {
  Vue.prototype.$config = AppConfig
}


export default AppConfig



// WEBPACK FOOTER //
// ./src/plugins/config.js